import { makeService } from './api';

const service = makeService('time_slots');

export default service;